import React, { useEffect } from "react"

const DashboardTable = ({ rows, columns, setDatatableLoading, exportTitle, encoding }) => {
  useEffect(() => {
    const handler = () => setDatatableLoading(false)
    window.addEventListener('datatable-ready', handler)
    return () => window.removeEventListener('datatable-ready', handler)
  }, [])

  useEffect(() => {
    if (columns.length > 0) {
      const timer = setTimeout(() => {window.dispatchEvent(new Event("csv-ready"))}, 10)
      return () => clearTimeout(timer)
    }
  }, [columns])

  return (
    <div 
      data-controller="exports--datatables"
      data-exports--datatables-title={exportTitle}
      data-exports--datatables-encoding={encoding || 'utf-8'}
    >
      <table 
        id        = "export_table" 
        className = "display stripe hover order-column">
        <thead>
          <tr>
            {columns.map(col => (
              <th key = {col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, id) => (
            <tr key = {id}>
              {columns.map(col => (
                <td key = {`${id}-${col}`}>
                  {row[col] || ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            {columns.map(col => (
              <th key = {`total-${col}`}></th>
            ))}
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

export default DashboardTable